import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Close = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 18, height: 18, fill: 'none', ...props.sx }}
    data-testid="closeIcon"
  >
    <path
      d="M6.9796 8.9999L1.92884 14.0507C1.37094 14.6086 1.37094 15.5131 1.92884 16.071C2.48673 16.6289 3.39125 16.6289 3.94914 16.071L8.9999 11.0202L14.0507 16.071C14.6086 16.6289 15.5131 16.6289 16.071 16.071C16.6289 15.5131 16.6289 14.6086 16.071 14.0507L11.0202 8.9999L16.071 3.94914C16.6289 3.39125 16.6289 2.48673 16.071 1.92884C15.5131 1.37094 14.6086 1.37095 14.0507 1.92884L8.9999 6.9796L3.94914 1.92884C3.39125 1.37094 2.48673 1.37094 1.92884 1.92884C1.37095 2.48673 1.37095 3.39125 1.92884 3.94914L6.9796 8.9999Z"
      fill="#0B1421"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.45743 1.45743C2.27567 0.639189 3.60231 0.63919 4.42055 1.45743L8.9999 6.03679L13.5793 1.45743C14.3975 0.639192 15.7241 0.63919 16.5424 1.45743C17.3606 2.27567 17.3606 3.60231 16.5424 4.42055L11.963 8.9999L16.5424 13.5793C17.3606 14.3975 17.3606 15.7241 16.5424 16.5424C15.7241 17.3606 14.3975 17.3606 13.5793 16.5424L8.9999 11.963L4.42055 16.5424C3.6023 17.3606 2.27567 17.3606 1.45743 16.5424C0.63919 15.7241 0.63919 14.3975 1.45743 13.5793L6.03679 8.9999L1.45743 4.42055C0.639193 3.60231 0.639191 2.27567 1.45743 1.45743ZM3.47774 2.40024C3.1802 2.1027 2.69778 2.1027 2.40024 2.40024C2.1027 2.69778 2.1027 3.18019 2.40024 3.47774L7.92241 8.9999L2.40024 14.5221C2.1027 14.8196 2.1027 15.302 2.40024 15.5996C2.69778 15.8971 3.18019 15.8971 3.47774 15.5996L8.9999 10.0774L14.5221 15.5996C14.8196 15.8971 15.302 15.8971 15.5996 15.5996C15.8971 15.302 15.8971 14.8196 15.5996 14.5221L10.0774 8.9999L15.5996 3.47774C15.8971 3.1802 15.8971 2.69778 15.5996 2.40024C15.302 2.1027 14.8196 2.1027 14.5221 2.40024L8.9999 7.92241L3.47774 2.40024Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default Close;
